import React from 'react';
import { Link } from 'react-router-dom';
import StoreLayout from './StoreLayout';
import { setLineQuantity, removeLine, bagCount } from './bag';
import { useBagLines, useSendBagToQuote } from './useBagLines';
import LineImage from './LineImage';
import { formatInr, useDocumentTitle, variantText } from './retailUtils';
import QtyStepper from './QtyStepper';

export default function StoreBagPage() {
  const { bag, lines, buyable, subtotal, blocked, loading } = useBagLines();
  const sendToQuote = useSendBagToQuote();
  useDocumentTitle('Bag');

  if (bag.length === 0) {
    return (
      <StoreLayout narrow>
        <div className="rt-empty">
          <h2>Your bag is empty</h2>
          <p>Browse the collection and add something you like.</p>
          <Link to="/catalog" className="rt-btn" style={{ marginTop: 12 }}>Start shopping</Link>
        </div>
      </StoreLayout>
    );
  }

  return (
    <StoreLayout>
      <h1 className="rt-page-title">Bag <span style={{ fontWeight: 500, color: '#6B7280', fontSize: 18 }}>({bagCount(bag)} item{bagCount(bag) !== 1 ? 's' : ''})</span></h1>
      <div className="rt-two-col">
        <div>
          {lines.map(l => (
            <div key={l.key} className={`rt-line${l.problem ? ' rt-line--bad' : ''}`}>
              <Link to={`/product/${l.productId}`} className="rt-line-img" tabIndex={-1} aria-hidden="true">
                <LineImage line={l} />
              </Link>
              <div style={{ minWidth: 0 }}>
                {l.product?.brandName && <div className="rt-card-brand">{l.product.brandName}</div>}
                {l.product
                  ? <Link to={`/product/${l.productId}`} className="rt-line-name">{l.product.name}</Link>
                  : <span className="rt-line-name">{loading ? 'Loading…' : 'Unavailable product'}</span>}
                <div className="rt-line-meta">
                  {[variantText(l), l.unitPrice != null ? `${formatInr(l.unitPrice)} each` : null].filter(Boolean).join(' · ')}
                </div>
                {!loading && l.problem && <div className="rt-line-meta" role="alert">{l.problem}</div>}
                <div className="rt-line-actions">
                  {l.product && l.maxQuantity > 0 && (
                    <QtyStepper small label={`Quantity for ${l.product.name}`} value={l.quantity}
                      max={Math.max(l.maxQuantity, 1)} onChange={q => setLineQuantity(l.key, q)} />
                  )}
                  <button type="button" className="rt-link" style={{ color: '#6B7280' }} onClick={() => removeLine(l.key)}>Remove</button>
                </div>
              </div>
              <div className="rt-line-price">{l.lineTotal != null && !l.problem ? formatInr(l.lineTotal) : ''}</div>
            </div>
          ))}
          <Link to="/catalog" className="rt-link" style={{ display: 'inline-block', marginTop: 16 }}>← Continue shopping</Link>
        </div>

        <aside className="rt-summary" aria-label="Order summary">
          <h2>Order summary</h2>
          <div className="rt-sum-row"><span>Subtotal ({buyable.reduce((n, l) => n + l.quantity, 0)} items)</span><span>{formatInr(subtotal)}</span></div>
          <div className="rt-sum-total"><span>Total</span><span>{formatInr(subtotal)}</span></div>
          <div className="rt-tax-note">Inclusive of all taxes</div>
          {blocked && !loading && <div className="rt-alert rt-alert--error" style={{ marginTop: 14, marginBottom: 0 }}>Fix or remove the highlighted items to continue.</div>}
          {/* Phase 1: the bag ends in a quote request; prepaid checkout replaces this in phase 2. */}
          <button type="button" className="rt-btn rt-btn--block" style={{ marginTop: 16 }}
            disabled={loading || blocked || buyable.length === 0} onClick={() => sendToQuote(buyable)}>
            Request a quote
          </button>
          <div className="rt-secure">We confirm the final price and delivery by email</div>
        </aside>
      </div>
    </StoreLayout>
  );
}
